import { useMocks } from '../../shared/env';
import type { PaymentsGateway } from './PaymentsGateway';
import { HttpPaymentsGateway } from './HttpPaymentsGateway';
import { MockPaymentsGateway } from './MockPaymentsGateway';

export const paymentsGateway: PaymentsGateway = useMocks ? new MockPaymentsGateway() : new HttpPaymentsGateway();
export type { PaymentsGateway } from './PaymentsGateway';
